import { Trans, useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { Config } from "./Config"

const Waiting = ({ admin }) => {
  const [dots, setDots] = useState("")

  useEffect(() => {
    const timeoutDots = setInterval(
      () => setDots((c) => (c.length === 3 ? "" : c + ".")),
      1000
    )

    return () => {
      clearInterval(timeoutDots)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <div className="d-flex justify-content-center align-items-center flex-row">
        <div className="col-6">
          <div className="title py-5">
            <Trans
              i18nKey={"games.tutti.starting"}
              values={{ op: admin?.nick }}
              components={{ strong: <strong /> }}
            />
            <br />
            {dots}
          </div>
        </div>
      </div>
    </>
  )
}

export const Esperando = ({ me, status, setStart }) => {
  const { t } = useTranslation()
  // me tengo que encontrar
  const myRoom = status.rooms.find((r) => r.players.includes(me.id)),
    admin = status.players.find((p) => p.id === myRoom?.admin),
    im_admin = admin?.id === me.id

  return im_admin ? (
    myRoom ? (
      <>
        <Config status={status} myRoom={myRoom} setStart={setStart} />
      </>
    ) : (
      `${t("ui.btns.loading")}...`
    )
  ) : (
    <Waiting admin={admin} />
  )
}
